import React from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';
import ClipboardcopyIcon from 'icons/Clipboardcopy.icon';
import useCopyToClipboard from 'hooks/useCopyToClipboard';

import './CopyTextBanner.styles.scss';

type CopyTextBannerProps = {
  className?: string;
  label?: string;
  text: string;
};

const CopyTextBanner: React.FC<CopyTextBannerProps> = (props) => {
  const { className, text, label } = props;

  const classes = classNames('copy-text-banner', className);

  const copyToClipboard = useCopyToClipboard();

  return (
    <div className={classes}>
      {label && <p>{label}</p>}

      <div className="copy-text-banner__container">
        <p>{text}</p>
        <Button
          variant="icon"
          icon={ClipboardcopyIcon}
          aria-label="Copy text."
          onClick={(e) => {
            copyToClipboard(e, text);
          }}
        />
      </div>
    </div>
  );
};

export default CopyTextBanner;
